import { Component, Input, ViewChildren, ViewChild, ElementRef, HostListener } from '@angular/core';
import moment from 'moment';
import { ReserveProvider } from '../../providers/reserve/reserve';
import { LocationsProvider } from '../../providers/locations/locations';
import { PopoverController, NavController, NavParams, ModalController, LoadingController, Platform, Events, ViewController, AlertController } from 'ionic-angular';
import { CoReserveCalendarComponent } from '../co-reserve-calendar/co-reserve-calendar';
import { ConfigProvider, ReserveBlock } from '../../providers/config/config';
import { CoRoomDetailsPage } from '../../pages/co-room-details/co-room-details';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { CoReserveRoomCardComponent } from '../co-reserve-room-card/co-reserve-room-card';
import { CoPopoverReserveFilterComponent } from '../co-popover-reserve-filter/co-popover-reserve-filter';
import { CoCartPage } from '../../pages/co-cart/co-cart';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { CoLoginComponent } from '../co-login/co-login';
import { LoginProvider } from '../../providers/login/login';
import { PatronProvider } from '../../providers/patron/patron';
import { CoCalendarComponent } from '../co-calendar/co-calendar';
import { CoReserveReservationsComponent } from '../co-reserve-reservations/co-reserve-reservations';
import { Observable } from 'rxjs';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { from } from 'rxjs/observable/from';
import { IsOpenPipe } from '../../pipes/is-open/is-open';
import { CoRoomSelectorPage } from '../../pages/co-room-selector/co-room-selector';

/**
 * Generated class for the CoReserveComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve',
  templateUrl: 'co-reserve.html',
  providers: [ IsOpenPipe ]
})
export class CoReserveComponent {
  @Input() locationId: number;
  @Input() mode: string = "multi";
  @Input() roomIds: Array<number>;
  @Input() currentDayOnly: boolean = false;
  @Input() libraryCardRequired: boolean = false;
  @Input() showScheduleNames: boolean;
  @Input() hideNotes: boolean;
  @Input() disableRightClick: boolean;
  @Input() tcOptional: boolean;
  @Input() pageTitle: string;
  @Input() branches: any;
  @Input() roomTitleFontSize: string;
  @Input() roomBookerLabel: string;
  @Input() scheduleLabel: string;
  @Input() expandRoomDetails: boolean;
  @Input() blockInfo: ReserveBlock;
  @Input() showPartialPatronDetails: boolean;
  @Input() showEmailInput: boolean;
  @Input() showPhoneInput: boolean;
  @Input() hideBookingTitle: boolean;
  @Input() showFullName: boolean;
  @Input() hideScheduleTab: boolean = false;
  @Input() requirePhone: boolean;
  @Input() requireEmail: boolean;
  @Input() hideLibraryCardAndPin: boolean = false;
  allRooms: any;
  unfiliteredRoomList: any;
  allLocations: any;
  allReservations: any = [];
  builtLocationsForPage: any;
  currentDay: any;
  todaysDate: any;
  finalArray: any;
  currentCart: any = [];
  clientKeyword: any;
  timezoneOffset: any;
  locationsById: any;
  realLocationById: any;
  viewType: string;
  // what are there 4 filter variables and can this be simplified
  stickyFilters: any = null;
  reserveFilters: any = {};
  filterParameters: any = { tracker: false };
  isFilterActive: any = {};
  stickyHeader: any;
  elementTop: number;
  documentElement: any;
  cardStyle: string;
  densitySwitches: any;
  currentTab: string = 'booker';
  roomScheduleRooms: any = {};
  locationOpen: any;
  locationClose: any;
  dataChange: boolean = false;
  intervalTime: boolean;
  intervalFunction: any;
  isCostEnabled: boolean;
  clientRoomSettings: any;
  headerLogoLink: any;
  fullClientDetails: any;
  locationClosed: boolean = false;
  roomsOpen: boolean = false;
  roomIdAddedToCart: number = undefined;
  roomIdsArray: Array<number> = [];
  userFoundLocation: any;
  userFoundLocationId: number;
  branchList: Array<any>;
  afterInitialLoad: boolean = false;
  reserveSignIn: boolean = false;
  roomDetailsModal;

  @ViewChild('dateSelector') dateSelector;
  @ViewChild('listContainer') listContainerElement: ElementRef;
  @ViewChildren(CoReserveRoomCardComponent) innerCards: Array<CoReserveRoomCardComponent>;

  public locationRooms: Array<any> = [];
  public currentDaySubject = new Subject<any>();
  public updateDay = new Subject<any>();
  public roomsUpdateSubject = new Subject<any>();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public reserveProvider: ReserveProvider,
    public locationProvider: LocationsProvider,
    public config: ConfigProvider,
    public popoverCtrl:PopoverController,
    public modalCtrl: ModalController,
    public clientDetails: ClientDetailsProvider,
    public state: AppState,
    public loading: LoadingController,
    public filteringProvider: FilteringProvider,
    private platform: Platform,
    private events: Events,
    private viewCtrl : ViewController,
    private alertCtrl: AlertController,
    private loginProvider: LoginProvider,
    private patronProvider: PatronProvider,
    private isOpenPipe: IsOpenPipe
    ) {
    let loader = this.loading.create({content: "Getting location..."});
    if ((!this.state.demo || this.state.staff) && !this.state.roomBooker) loader.present();
    this.userFoundLocationId = this.state.locationId;
    this.reserveSignIn = this.state.reserveSignIn;
    if ((this.state.demo && !this.state.staff) || (this.state.sharedScreen && this.state.roomBooker)){
      this.locationProvider.getLocations().then(locations => {
        loader.dismiss().catch(err=>{});
        this.branchList = locations;
        // console.log(locations, this.state.locationId);
        if(!this.state.locationId) {
          this.showRoomPicker();
          return;
        }
        this.userFoundLocation = locations.find(b =>{return b.id == this.state.locationId});
        this.userFoundLocationId = this.userFoundLocation.id;
        this.initFunction();
      });
    } else {
      this.locationProvider.getUserLocation().then(coords =>{
        if (coords && coords.lat !== ''){
          this.locationProvider.getNearestLocations(coords.lat, coords.lng).then(l=>{
            loader.dismiss().catch(err=>{});
            this.userFoundLocation = l[0];
            // console.log(l);
            this.userFoundLocationId = l[0].id;
            this.locationId = this.userFoundLocationId;
            this.branchList = l.sort((a, b) => a.name.localeCompare(b.name));
            this.initFunction();
          });
        } else {
          this.locationProvider.getLocations().then(locations => {
            loader.dismiss().catch(err=>{});
            this.branchList = locations;
            // console.log(locations, this.state.locationId);
            this.userFoundLocation = locations.find(b =>{return b.id == this.state.locationId});
            this.userFoundLocationId = this.userFoundLocation.id;
            this.initFunction();
          });
        }
      }).catch(err =>{
        this.locationProvider.getLocations().then(locations => {
          loader.dismiss().catch(err=>{});
          this.branchList = locations;
          // console.log(locations, this.state.locationId);
          this.userFoundLocation = locations.find(b =>{return b.id == this.state.locationId});
          this.userFoundLocationId = this.userFoundLocation.id;
          this.initFunction();
        });
      });
    }

    this.currentDaySubject.subscribe(async (currentDate) => {
      let roomHours = ((((this.allRooms || [{}])[0] || {}).roomHours || [])[moment(currentDate).day()]);
      let keys = Object.keys(this.realLocationById || {});

      let locationHoursForDay = null;
      if(keys.length > 0) {
        let locationHours;
        locationHours = this.realLocationById[keys[0]].locationHours;
        if(locationHours[moment(currentDate).day()]) {
          if((locationHours[moment(currentDate).day()] || { date:null}).date === moment(currentDate).format("YYYY-MM-DD")) {
            locationHoursForDay = locationHours[moment(currentDate).day()].date;
          }
        }
      }

      if(null == locationHoursForDay) {
        await this.updateLocationHours();
      }

      if((roomHours || {}).date !==  moment(currentDate).format("YYYY-MM-DD")) {
        await this.getAllRooms(moment(currentDate));
      }

      this.roomsOpen = this.allRooms.some((room) => {
        let hours = room.roomHours[moment(currentDate).day()];
        return !("0:00" == hours.start && "0:00" == hours.end);
      });

      this.applyFilters();
      this.updateDay.next(currentDate);
    });
  }

  @HostListener('document:contextmenu', ['$event'])
  onDocumentRightClick(event) {
    if (this.disableRightClick) {
      event.preventDefault();
    }
  }

  ngAfterViewInit() {

  };

  onScroll(event) {
    if (event.scrollTop > this.elementTop) {
      if (this.state.mode === "desktop" || this.viewType === "app") {
        this.stickyHeader.classList.add('fixed');
        this.stickyHeader.classList.add('noTop');
        if (this.listContainerElement) {
          this.listContainerElement.nativeElement.classList.add('fixScrollingIssue');
        }
      }
    }
    else {
      if (this.state.mode === "desktop" || this.viewType === "app") {
        this.stickyHeader.classList.remove('fixed');
        this.stickyHeader.classList.remove('noTop');
        if (this.listContainerElement) {
          this.listContainerElement.nativeElement.classList.remove('fixScrollingIssue');
        }
      }
    }
  }

  // ngOnInit() {
  //   if(!this.roomBookerLabel) {
  //     this.roomBookerLabel = "Room Booker";
  //   }
  //   if(!this.scheduleLabel) {
  //     this.scheduleLabel = "Schedule";
  //   }
  //   if(!this.roomTitleFontSize || this.roomTitleFontSize === '') {
  //     this.roomTitleFontSize = "16px";
  //   }
  //   this.viewType = this.state.mode;
  //   this.currentDay = moment().startOf('minute').format("YYYY-MM-DD HH:mm:ss");
  //   if (!this.locationId) {
  //     this.locationId = this.state.locationId;
  //   }
  //   if (this.branches) {
  //     if (this.locationId) {
  //       if (this.branches[this.locationId]) {
  //         this.branches[this.locationId].forEach(branch => {
  //           this.roomIdsArray.push(branch);
  //         });
  //       }
  //     } else if (this.branches[this.state.locationId]) {
  //       this.branches[this.state.locationId].forEach(branch => {
  //         this.roomIdsArray.push(branch);
  //       });
  //     }
  //   }
  //   this.clientDetails.load().then((res) => {
  //     // console.log(res);
  //     this.fullClientDetails = res;
  //     this.clientKeyword = res.keyword;
  //     this.timezoneOffset = res.timezone[0].offset;
  //     this.isCostEnabled = res.settings.rooms_charging_enabled;
  //     if (this.mode === 'single') {
  //       this.isCostEnabled = false;
  //     }
  //     this.clientRoomSettings = res.settings;
  //   });
  //   this.config.load(this.state.appId).then((res) => {
  //     this.headerLogoLink = res.theme.headerLogo;
  //   })
  //   if (this.mode === 'single') {
  //     this.cardStyle = 'tablet';
  //   } else if (this.mode === 'multi') {
  //     this.cardStyle = 'standard';
  //   }
  //   this.intervalTime = true;
  //   this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
  //   this.intializePage();
  // }

  initFunction(){
    if(!this.roomBookerLabel) {
      this.roomBookerLabel = "Room Booker";
    }
    if(!this.scheduleLabel) {
      this.scheduleLabel = "Schedule";
    }
    if(!this.roomTitleFontSize || this.roomTitleFontSize === '') {
      this.roomTitleFontSize = "16px";
    }
    this.viewType = this.state.mode;
    this.currentDay = moment().startOf('minute').format("YYYY-MM-DD HH:mm:ss");
    this.currentDaySubject.next(this.currentDay);
    if (!this.locationId) {
      this.locationId = this.state.locationId;
    }
    if (this.branches) {
      if (this.locationId) {
        if (this.branches[this.locationId]) {
          this.branches[this.locationId].forEach(branch => {
            this.roomIdsArray.push(branch);
          });
        }
      } else if (this.branches[this.state.locationId]) {
        this.branches[this.state.locationId].forEach(branch => {
          this.roomIdsArray.push(branch);
        });
      }
    }
    this.clientDetails.load().then((res) => {
      // console.log(res);
      this.fullClientDetails = res;
      this.clientKeyword = res.keyword;
      this.timezoneOffset = res.timezone[0].offset;
      this.isCostEnabled = res.settings.rooms_charging_enabled;
      if (this.mode === 'single') {
        this.isCostEnabled = false;
      }
      this.clientRoomSettings = res.settings;
    });
    this.config.load(this.state.appId).then((res) => {
      this.headerLogoLink = res.theme.headerLogo;
    })
    if (this.mode === 'single') {
      this.cardStyle = 'tablet';
    } else if (this.mode === 'multi') {
      this.cardStyle = 'standard';
    }
    this.intervalTime = true;
    this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
    this.intializePage();
  }

  showRoomPicker() {
    this.branches = {};
    let modal = this.modalCtrl.create(CoRoomSelectorPage, { cssClass: 'full-screen-modal', enableBackdropDismiss: false });
    modal.onWillDismiss(() => {
      if (Object.keys(this.branches).length === 0) {
        alert('No rooms selected. Please select at least 1 room.');
        modal.present();
      }
    });
    modal.present();
    this.events.subscribe('SelectedRooms', branches => {
      modal.dismiss().catch(err=>{});
      if (Object.keys(branches).length === 0) return;
      else if (Object.keys(branches).length > 1) {
        this.mode = 'multi';
      } else {
        this.mode = 'single';
        this.locationId = parseInt(Object.keys(branches)[0]);
      }
      this.branches = branches;
      this.initFunction();
    });
  }

  tappedClock(e) {
    if(e.tapCount === 10) {
      let alert = this.alertCtrl.create({
        title: 'Logout',
        cssClass: 'confirm-alert',
        message: 'What do you want to do?',
        buttons: [
          {
            text: 'Select Different Rooms',
            cssClass: 'confirm-button-fullwidth',
            handler: () => {
              this.locationRooms = null;
              this.showRoomPicker();
            }
          },
          {
            text: 'Log Out',
            cssClass: 'confirm-button-fullwidth',
            handler: () => {
              this.events.publish('staff:logout');
            }
          },
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'confirm-button-fullwidth-outline',
            handler: () => {
              return;
            }
          }
        ]
      });
      alert.present();
    }
  }

  setNewLocation(){
    if (this.afterInitialLoad){
      console.log('loaded');
      this.currentTab = 'booker';
      this.afterInitialLoad = false;
      this.finalArray = undefined;
      this.locationId = this.userFoundLocationId;
      this.roomIdsArray = [];
      this.allRooms = [];
      this.roomScheduleRooms = {};
      if (this.branches) {
        if (this.locationId) {
          if (this.branches[this.locationId]) {
            this.branches[this.locationId].forEach(branch => {
              this.roomIdsArray.push(branch);
            });
          }
        } else if (this.branches[this.state.locationId]) {
          this.branches[this.state.locationId].forEach(branch => {
            this.roomIdsArray.push(branch);
          });
        }
      }
      this.intializePage();
    }
  }

  displayTime() {
    this.intervalFunction = setInterval(() => {
      if(!moment().isSame(moment(this.todaysDate, "YYYY-MM-DD HH:mm:ss"), "day")) {
        this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
        this.currentDay = moment().format("YYYY-MM-DD HH:mm:ss");
      }
      if (moment().hour() === 0 && moment().minute() === 0) {
        this.currentDay = moment().format("YYYY-MM-DD HH:mm:ss");
        this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.intervalTime) {
        this.currentDay = moment(this.currentDay).hour(moment().hour()).minute(moment().minute()).startOf('minute').format("YYYY-MM-DD HH:mm:ss");
        this.setCurrentDate();
      }
      this.currentDaySubject.next(this.currentDay);
    }, 60000);
  }

  ngOnDestroy() {
    this.intervalTime = false;
    clearInterval(this.intervalFunction);
  }

  async intializePage() {
    this.displayTime();
    this.getAllLocations();
    await this.getAllReservations();
    await this.getAllRooms(moment());
  }

  goBack() {
    this.navCtrl.pop()
  }

  isFullyBooked(room) {
    let todaysHours = room.roomHours[moment(this.currentDay).day()];
    return (todaysHours.end == "0:00" && todaysHours.start == "0:00");
  }

  getRoomSchedule(room) {
    let todaysHours = room.roomHours[moment(this.currentDay).day()];
    if(todaysHours.end == "0:00" && todaysHours.start == "0:00") {
      return [{
        closedForDay: true,
        start: moment().hour(0).minute(1),
        end: moment().hour(23).minute(59),
        available: false,
        'patronInfo': {
          'lastName': ''
        }
      }];
    }

    return this.roomScheduleRooms[room.id];
  }


  //TODO: call this when the room is changed
  async getAllRooms(date) {
    let loader = this.loading.create({content: 'Retrieving rooms list'});

    loader.present();
    if (this.mode === 'multi') {
      await this.reserveProvider.getAllRooms(date).then((res) => {
        if (this.branches) {
          let roomList = [];
          for (let key in this.branches){
            roomList = roomList.concat(this.branches[key]);
          }
          this.allRooms = res.filter(room =>{
            return roomList.indexOf(room.id) > -1;
          });
          // console.log(roomList, res, this.allRooms);
          this.unfiliteredRoomList = this.allRooms;
          this.createRoomListForPage(this.allRooms);
        } else {
          // console.log('im here');
          this.allRooms = res;
          this.unfiliteredRoomList = res;
          this.createRoomListForPage(res);
        }
      });
    } else if (this.mode === 'single') {
      await this.reserveProvider.getRooms(this.locationId, date).then((res) => {
        this.allRooms = [];
        if (this.roomIds && this.roomIds.length > 0) {
          this.allRooms = res.filter(room =>{
            return this.roomIds.indexOf(room.id) > -1;
          });
        } else if (this.branches) {
          this.allRooms = res.filter(room =>{
            return this.roomIdsArray.indexOf(room.id) > -1;
          })
        } else {
          this.allRooms = res;
        }
        this.unfiliteredRoomList = this.allRooms;
        this.createRoomListForPage(this.allRooms);
      });
    }
    loader.dismiss().catch(err=>{});
  };

  async getAllReservations() {
      await this.reserveProvider.getReservations(moment(this.currentDay).startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment(this.currentDay).endOf('day').format('YYYY-MM-DD HH:mm:ss')).then((res) => {
        this.allReservations = res.filter(reservation => {
          return (reservation.status !== 'cancelled' && reservation.status !== 'declined' && reservation.noShow !== 1 && reservation.noShow !== 3);
        });
      });
    return;
  }

  /**
   *
   * @param rooms - filter the rooms array and find rooms that are available
   * @returns  a list of open rooms for the location
   */
  locationAvailableRooms(rooms) {
  if(this.mode == 'single') {
    if(rooms) {
      let filteredRooms = rooms.filter((room) => {
        return this.isRoomInConfig(room.id);
      });
      return filteredRooms;
    }
    return [];
  }

    let openRooms =  [];

    openRooms = (rooms || []).filter((room) => {
        let hours = room.roomHours[moment(this.currentDay).day()];
        return !("0:00" == hours.start && "0:00" == hours.end);
    });
    return openRooms;
  }

  /**
   *
   * @returns a list of locations with open rooms
   */
  locations() {
    if(this.mode == 'single') {
      if(this.branches && this.branches[this.locationId]) {
        if(this.branches[this.locationId].length == 0) {
          return [];
        }
      }
    }

    let locations = [];
    if (this.locationRooms) {
      locations = this.locationRooms.filter(location => {
        const d = moment(this.currentDay).day();
        let isLocationOpen = (location.hours[d].start !== location.hours[d].end);

        let roomsHours = location.rooms.map((room) => {
          let hours = room.roomHours[moment(this.currentDay).day()];
          if(hours) {
            return hours;
          } else {
            return null;
          }
        });

        let roomsOpen = roomsHours.some((hours) => {
          return !("0:00" == hours.start && "0:00" == hours.end);
        });

        if(roomsOpen) {
          this.roomsOpen = true;
        }

        if(roomsHours.length > 0) {
          return roomsOpen;
        } else {
          return isLocationOpen;
        }
      });
    }

    return locations;
  }

  /**
   * @returns boolean, true if the locationRooms parameter has been set.
   */
  locationHasRooms() {
    if (null == this.locationRooms) {
      return false;
    }
    return true;
  }

  isLocationClosed() {
    let locationClosed = (this.locationClosed && !this.roomsOpen);
    return locationClosed;
  }

  initLocationRooms() {
    if(this.afterInitialLoad) {
      return;
    }

    this.roomsUpdateSubject.subscribe((rooms) => {
      let arr = [...this.finalArray];
      let res = arr.filter(location => {
        const d = moment(this.currentDay).day();
        return (this.roomsOpen || (location.hours[d].start !== location.hours[d].end));
      });
      this.locationRooms = res;
      this.roomsOpen = this.allRooms.some((room) => {
        let hours = room.roomHours[moment(this.currentDay).day()];
        return !("0:00" == hours.start && "0:00" == hours.end);
     });
    });

    this.updateDay.subscribe((day) => {
        this.roomsOpen = this.allRooms.some((room) => {
            if(false == this.isRoomInConfig(room.id)) {
                return false;
            }
            let hours = room.roomHours[moment(day).day()];
            return !("0:00" == hours.start && "0:00" == hours.end);
        });
        let arr = [...this.finalArray];
        let res = arr.filter(location => {
           const d = moment(day).day();
           return (this.roomsOpen || (location.hours[d].start !== location.hours[d].end));
        });
        this.locationRooms = res;
   });
  }

  isRoomInConfig(roomid) {
    if(this.mode == 'single') {
      if(this.locationId) {
        if(this.branches && this.branches[this.locationId]) {
          if(this.branches[this.locationId].indexOf(roomid) == -1) {
            return true;
          }
        }
      }
    }

    return true;
  }

  createRoomListForPage(rawRoomsList) {
    this.initLocationRooms();
    let roomsObject, visibleRooms;
      visibleRooms = rawRoomsList.filter((room) => {
        return room.viewable || (room.localOnly && (this.state.sharedScreen || this.state.staff)) || this.state.staff ? room : false;
      });
      // console.log(visibleRooms, rawRoomsList)
    roomsObject = visibleRooms.reduce((red, room) => {
      // let locationId = ;
      if (!red[room.locationId]) {
        red[room.locationId] = [];
      }
      red[room.locationId].push(room);
      return red;
    }, {});
    this.finalArray = Object.keys(roomsObject).map((key) => {
      let finalObject;

      if (this.mode === 'multi') {
        finalObject = {
          rooms: roomsObject[key],
          branchName: this.realLocationById[key].name,
          hours: this.realLocationById[key].locationHours
        };
      } else if (this.mode === 'single') {

        finalObject = {
          rooms: roomsObject[key],
          branchName: this.realLocationById.name,
          hours: this.realLocationById[this.locationId].locationHours
        };
        finalObject.rooms.sort((a,b) => {
          // return a.id-b.id;
          return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
        });
      }
      return finalObject;
    });
    this.roomsUpdateSubject.next(this.currentDay);
    this.afterInitialLoad = true;
  }

  goToRoomDetails(room) {
    // this.config.load(this.state.appId).then(cfg => {
    //   this.navCtrl.push(CoRoomDetailsPage, { room: room, currentDay: this.currentDay, previousView: this, locations: this.locationsById, mode: this.mode, isCostEnabled: this.isCostEnabled, clientDetails: this.fullClientDetails, headerLogo: this.headerLogoLink, currentDayOnly: this.currentDayOnly, pageTitle: this.pageTitle, expandRoomDetails: this.expandRoomDetails });
    // });
    // this.roomIdAddedToCart = undefined;

    this.config.load(this.state.appId).then(cfg => {
      this.roomDetailsModal = this.modalCtrl.create(CoRoomDetailsPage, { room: room, currentDay: this.currentDay, previousView: this, locations: this.locationsById, mode: this.mode, isCostEnabled: this.isCostEnabled, clientDetails: this.fullClientDetails, headerLogo: this.headerLogoLink, currentDayOnly: this.currentDayOnly, pageTitle: this.pageTitle, expandRoomDetails: this.expandRoomDetails, isModal: true }, {cssClass: 'full-screen-modal'});
      this.roomDetailsModal.present();
      this.roomDetailsModal.onDidDismiss( () => {
        if(this.mode === 'single') {
          this.currentCart = [];
        }
      });
    });
    this.roomIdAddedToCart = undefined;
  }

  getAllLocations() {
    if (this.mode === 'multi') {
      // this.locationProvider.getLocations().then((res) => {
        this.allLocations = this.branchList;
        this.locationsById = [];
        this.realLocationById = {};
        this.allLocations.find((res) => {
          this.locationsById.push(res);
          this.realLocationById[res.id] = res;
        });
        // console.log(this.locationsById, this.realLocationById);
        // this.toggleView();
      // });
    } else if (this.mode === 'single') {
      // this.locationProvider.getLocation(this.locationId).then((res) => {
        let loc = this.branchList.find(r => r.id === this.locationId);
        this.allLocations = loc;
        this.locationsById = [];
        this.realLocationById = {};
        this.locationsById.push(loc);
        // this.realLocationById = res;
        this.realLocationById[loc.id] = loc;
        this.updateLocationHours();
        // this.allLocations.find((res) => {
        //   this.locationsById.push(res);
        //   this.realLocationById[res.id]=res;
        // });
      // });
    }
  };

  async updateLocationHours() {
    if (this.mode === 'multi') {
      return;
    }
    let dayHours = moment(this.currentDay);
    if(null == this.locationId) {
      return;
    }
    await this.locationProvider.getWeekHours(this.locationId, dayHours.format('YYYY-MM-DD'), true).then((res) => {
      this.realLocationById[this.locationId].locationHours = res;
      let start = [this.realLocationById[this.locationId].locationHours[moment(this.currentDay).day()].start.split(':')[0], this.realLocationById[this.locationId].locationHours[moment(this.currentDay).day()].start.split(':')[1].split(' ')[0]];
      let end = [this.realLocationById[this.locationId].locationHours[moment(this.currentDay).day()].end.split(':')[0], this.realLocationById[this.locationId].locationHours[moment(this.currentDay).day()].end.split(':')[1].split(' ')[0]];

      this.locationOpen = moment(this.currentDay).hour(Number(start[0])).minute(Number(start[1])).startOf('minute');
      this.locationClose = moment(this.currentDay).hour(Number(end[0])).minute(Number(end[1])).startOf('minute');

      if (this.locationOpen.isSame(this.locationClose)) {
        this.locationClosed = true;
      } else {
        this.locationClosed = false;
      }
    });
  }

  applyReserveSidebarFilters(event) {
    this.reserveFilters[event.type] = event.stats;
    this.filterByPopOver(this.reserveFilters);
  }

  presentPopover(myEvent, filterParams) {
    let customClass = '';
    this.viewType === 'app' ? customClass = 'custom-popover-app' : customClass = 'custom-popover-desktop';
    let popover = this.popoverCtrl.create(CoPopoverReserveFilterComponent, { data: filterParams, current: this.filterParameters }, { cssClass: customClass });
    popover.present({
      ev: myEvent
    });

    popover.onDidDismiss(data => {
      if (data) {
        if (data.type != 'resetAll') {
          this.filterParameters.tracker = true;
          this.filterParameters[data.type] = data.stats;
          if (data.stats.length > 0) {
            this.isFilterActive[data.type] = data.on;
          } else {
            this.isFilterActive[data.type] = false;
          }
          this.reserveFilters = this.filterParameters;
          this.filterByPopOver(this.reserveFilters);
          this.stickyFilters = this.reserveFilters;
        } else if (data.type === 'resetAll') {
          this.filterParameters = { tracker: true };
          // passed to this.filterByPopOver
          let filters = this.filterParameters;
          this.reserveFilters = this.filterParameters;
          // is filter active
          for (let key in this.isFilterActive) {
            this.isFilterActive[key] = false;
          };
          this.filterByPopOver(filters)

        } else {
          console.log('something is wrong with resetAll param on dismiss', data);
        };
      }
    });
  }

  filterByPopOver(filterObj) {
    this.stickyFilters = filterObj;
    this.applyFilters();

    this.currentDaySubject.next(this.currentDay);
  }
  applyFilters() {
    if(null != this.stickyFilters) {
      this.filteringProvider.filterRooms(this.stickyFilters, this.allRooms).then((res) => {
        this.createRoomListForPage(res);
      });
    }
  }

  async previousDay() {

    if (moment(this.currentDay).format("YYYY-MM-DD") === moment(this.todaysDate).format("YYYY-MM-DD")) {
      return;
    }

    let self = this;
    let loader = this.loading.create({
      content: "Loading data..."
    });

    loader.present();
    this.currentDay = moment(this.currentDay).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.currentDaySubject.next(this.currentDay);

    await this.getAllReservations().then(() => {
      this.innerCards.forEach(element => {
        let roomReservations = [];
        this.allReservations.forEach(reservation => {
          if (reservation.roomId === element.roomDetails.id) {
            roomReservations.push(reservation);
          }
        });
        // console.log(roomReservations);
        element.initializeCard(this.currentDay, roomReservations);
      });
      if (self.currentTab === 'schedule') {
        self.attachEventsToRoom();
      } else {
        self.updateLocationHours();
      }
    });
    loader.dismiss().catch(err=>{});
  }

  async nextDay() {
    let self = this;
    let loader = this.loading.create({
      content: "Loading data..."
    });

    loader.present();
    this.currentDay = moment(this.currentDay).add(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.currentDaySubject.next(this.currentDay);
    await this.getAllReservations().then(() => {

      this.innerCards.forEach(element => {
        let roomReservations = [];
        this.allReservations.forEach(reservation => {
          if (reservation.roomId === element.roomDetails.id) {
            roomReservations.push(reservation);
          }
        });
        // console.log(roomReservations);
        element.initializeCard(this.currentDay, roomReservations);
      });

      if (self.currentTab === 'schedule') {
        self.attachEventsToRoom();
      } else {
        self.updateLocationHours();
      }
    });

    loader.dismiss().catch(err=>{});
  }

  attachEventsToRoom() {
    this.updateLocationHours().then( () => {
      this.allRooms.forEach(r => {
        // if (element.viewable) {
          // console.log(element);
          r.events = [];
          this.allReservations.forEach(reservation => {
            if (reservation.roomId === r.id) {
              r.events.push(reservation);
            }
          });
          // console.log(r);
          this.showRoomEvents(r);
        // }
      });
    });
  }
  openDatePicker(){
    let popover = this.popoverCtrl.create(CoCalendarComponent, { popup: true, range: false }, { cssClass: 'date-time-popover' });
    popover.present();

    popover.onDidDismiss(data => {
      if(data && data.date){
				this.goToDate(data.date);
      }
    });
  }

  async goToDate(date) {
    let self = this;
    let loader = this.loading.create({
      content: "Loading reservations..."
    });
    loader.present();

    this.currentDay = moment(date, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
    if(this.currentDay === "Invalid date") {
      this.currentDay = moment(date, "D MMMM YYYY").format("YYYY-MM-DD HH:mm:ss");
    }
    if(this.currentDay === "Invalid date") {
      this.currentDay = moment(date, "DD MMM YYYY").format("YYYY-MM-DD HH:mm:ss");
    }

    this.currentDaySubject.next(this.currentDay);

    await this.getAllReservations().then(async () => {
      this.innerCards.forEach(async (element) => {
        let roomReservations = [];
        this.allReservations.forEach(async (reservation) => {
          if (reservation.roomId === element.roomDetails.id) {
            roomReservations.push(reservation);
          }
        });
        // console.log(roomReservations);
        element.initializeCard(this.currentDay, roomReservations);
      });
      if (self.currentTab === 'schedule') {
        self.attachEventsToRoom();
    	loader.dismiss().catch(err=>{});
      } else {
        await self.updateLocationHours();
        loader.dismiss().catch(err=>{});
      }
    });
  }

  async setCurrentDate() {
    // let loader = this.loading.create();
    let self = this;
    // loader.present();
    await this.getAllReservations().then(() => {
      this.innerCards.forEach(element => {
        element.initializeCard(this.currentDay, this.allReservations);
      });
      if (self.currentTab === 'schedule') {
        self.attachEventsToRoom();
      } else {
        self.updateLocationHours();
      }
    });
    // loader.dismiss();
  }

  patronSignIn() {
    let modal = this.modalCtrl.create(CoLoginComponent, { dismissButton: 'close', login: (barcode, pin) => this.patronProvider.getSummaryDetails(barcode, pin) }, { cssClass: `loginModalBase`, enableBackdropDismiss: false });
    modal.present();
    modal.onDidDismiss(res => {
      if (res && (res.id || res.pin)){
        let reservationsModal = this.modalCtrl.create(CoReserveReservationsComponent, { patron: res }, { cssClass: `loginModalBase`, enableBackdropDismiss: false });
        reservationsModal.present();
      }
    });
  }

  openCalendar(event) {
    let popover = this.popoverCtrl.create(CoReserveCalendarComponent, { reservePage: this, currentDay: this.currentDay }, { cssClass: 'reserve-calendar-popover' });
    popover.present({
      ev: event
    });

  }

  goToCart(event, checkout: boolean, detailsScreen?) {
    this.roomIdAddedToCart = undefined;
    let self = this;
    if (detailsScreen === undefined) {
      detailsScreen = false;
	  }
    if (this.state.mode === "app" && checkout && !this.state.staff && this.libraryCardRequired) {
      let modal = this.modalCtrl.create(
        CoLoginComponent,
        { pinless: this.state.pinless, login: (barcode, pin) => this.loginProvider.login(barcode, pin) },
        { cssClass: `loginModalBase`, enableBackdropDismiss: false }
      );
      modal.present();
      modal.onWillDismiss(res => {
      });
      modal.onDidDismiss(res => {
        if (res === undefined) {
          return null;
        }
        let modal = this.modalCtrl.create(
          CoCartPage,
          { barcode:res.barcode, currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: true, popover: false, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
          { cssClass: "co-cart-modal", enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
        );
        if (this.mode === 'single') {
        modal.onDidDismiss((data) => {
          if (data && data.clearCart) {
            self.emptyCartUserClose();
          }
          else {
            self.emptyCart();
          }
        });
        }
        modal.present();
      });
    } else if(this.state.mode === "app" && checkout && !this.state.staff) {
      let modal = this.modalCtrl.create(
        CoCartPage,
        { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: true, popover: false, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
        { cssClass: "co-cart-modal", enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
      );
      if (this.mode === 'single') {
        modal.onDidDismiss((data) => {
          if (data && data.clearCart) {
            self.emptyCartUserClose();
          }
        });
      }
      modal.present();
	  } else if (this.state.mode === "app" && !checkout) {
      let modal = this.modalCtrl.create(
        CoCartPage,
        { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: false, popover: false, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
        { cssClass: "co-cart-modal", enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
      );
      if (this.mode === 'single') {
        modal.onDidDismiss((data) => {
          if (data && data.clearCart) {
            self.emptyCartUserClose();
          }
        });
      }
      modal.present();
    }
    else if (this.state.mode === "app" && checkout) {
      let modal = this.modalCtrl.create(
        CoCartPage,
        { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: true, popover: false, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
        { cssClass: "co-cart-modal", enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
      );
      if (this.mode === 'single') {
        modal.onDidDismiss((data) => {
          if (data && data.clearCart) {
            self.emptyCartUserClose();
          }
        });
      }
      modal.present();
    }
    else if (this.state.mode === "desktop" && !checkout) {
      if (this.platform.width() <= 430) {
        let modal = this.modalCtrl.create(
          CoCartPage,
          { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: false, popover: false, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
          { cssClass: "co-cart-modal", enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
        );
        if (this.mode === 'single') {
          modal.onDidDismiss((data) => {
            if (data && data.clearCart) {
              self.emptyCartUserClose();
            }
          });
        }
        modal.present();
      } else {
        let popover = this.popoverCtrl.create(
          CoCartPage,
          { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: false, popover: true, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
          { cssClass: 'custom-cart-popover', enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
        );
        popover.present({
          ev: event
        });
      }
    }
    else if (this.state.mode === "desktop" && checkout) {
      let modal = this.modalCtrl.create(
        CoCartPage,
        { currentCart: this.currentCart, clientKeyword: this.clientKeyword, previousPage: this, viewingCart: true, popover: false, mode: this.mode, isCostEnabled: this.isCostEnabled, clientRoomSettings: this.clientRoomSettings, viewType: this.viewType, clientName: this.fullClientDetails.longName, detailsScreen: detailsScreen, libraryCardRequired: this.libraryCardRequired, tcOptional: this.tcOptional, hideNotes: this.hideNotes, blockSettings: this.blockInfo },
        { cssClass: "co-cart-modal", enableBackdropDismiss: !this.state.disableCartBackdropDismiss }
      );
      if (this.mode === 'single') {
        modal.onDidDismiss((data) => {
          if (data && data.clearCart) {
            self.emptyCartUserClose();
          }
        });
      }
      modal.present();
    }
  }

  addToCart(booking) {
    booking.cartId = this.currentCart.length;
    this.currentCart.push(booking);
    this.roomIdAddedToCart = booking.room.id;
  }

  removeBooking(num, cartId?) {
    if (cartId) {
      let i = 0;
      this.currentCart.forEach(item => {
        if (item.cartId === cartId) {
          this.currentCart.splice(i, 1);
          return;
        }
        i = 0;
      });
    } else {
      this.currentCart.splice(num, 1);
    }
  }

  resetCartIds() {
    for (let i = 0; i < this.currentCart.length; i++) {
      this.currentCart[i].cartId = i;
    }
  }

  emptyCart() {
    this.currentCart = [];
  }

  emptyCartUserClose() {
    this.currentCart = [];
    this.roomDetailsModal.dismiss();
  }

  // async roomIsEvents(startTime, endTime) {
  //   let self = this
  //   await self.allRooms.forEach(element => {
  //     self.reserveProvider.getReservations(startTime, endTime, element.id).then((event) => {
  //       // roomEvents.push([]);
  //       // roomEvents[i].push(event);
  //       // if (!element.events) {
  //       element.events = JSON.parse(JSON.stringify(event));
  //       element.events.sort((a, b) => {
  //         return moment(a.startTime).isSame(moment(b.startTime))
  //       })
  //       self.showRoomEvents(element)
  //       // }
  //       // element.events.push(event);
  //       // i++;
  //     });
  //   });
  //   return self.allRooms
  // }

  getHours(room, day) {
    let locOpen = this.locationOpen;
    let locClose = this.locationClose;

    if(room.roomHours) {
      let hourSet = room.roomHours[day];
      const date = moment(this.currentDay).format("YYYY-MM-DD");
      locOpen = moment(date + ' ' + hourSet.start, "YYYY-MM-DD h:mm");
      locClose = moment(date + ' ' + hourSet.end, "YYYY-MM-DD h:mm");
    }
    return[ locOpen, locClose ];
  }

  showRoomEvents(room) {
    const [ start, end ] = this.getHours(room, moment(this.currentDay).day());
    let openingTime = start.add(room.dayStartBuffer, 'minutes').format("YYYY-MM-DD HH:mm:ss");
    let closingTime = end.subtract(room.dayEndBuffer, 'minutes').format("YYYY-MM-DD HH:mm:ss");

    room.events.sort((a, b) => {
      return moment(a.startTime).diff(moment(b.startTime));
    });

    // only display bookings within room hours
    room.events.forEach( (event) => {
      if(moment(event.startTime).isBefore(openingTime)) {
        event.startTime = openingTime;
      }
      if(moment(event.endTime).isAfter(closingTime)) {
        event.endTime = closingTime;
      }
    });

    // bookings might now have the same start and end time, remove those
    room.events = room.events.filter( (event) => {
      return event.startTime !== event.endTime;
    });
    this.roomScheduleRooms[room.id] = [];

    if (room.events.length > 0) {
      let ArrLength = room.events.length - 1;
      for (let x = 0; x < room.events.length; x++) {
        let last, barcode;
        let firstName = room.events[x].firstName || "";
        let lastName = room.events[x].lastName || "";
        // lastName !== "" ? last = `${room.events[x].lastName.split('').slice(0,4).join('')}...` : last = "";
        lastName !== "" && firstName !== "" ? last = `${room.events[x].lastName.split('').slice(0,4).join('')} ${room.events[x].firstName.split('').slice(0,1).join('')}` : last = "";
        room.events[x].libraryCard ? barcode = `(card ...${room.events[x].libraryCard.split('').reverse().slice(0, 4).reverse().join('')})`  : barcode = "";

        // console.log(last, barcode, firstName, lastName);
        if (x === 0 && moment(openingTime).isSame(room.events[0].startTime)) {
          this.roomScheduleRooms[room.id].push({ start: openingTime, end: room.events[0].endTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} });
          if (room.events.length === 1 && !moment(room.events[0].endTime).isSameOrAfter(moment(closingTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[0].endTime, end: closingTime, available: 'true'})
          }
        } else if (x === 0) {
          this.roomScheduleRooms[room.id].push({ start: openingTime, end: room.events[0].startTime, available: 'true'})
          this.roomScheduleRooms[room.id].push({ start: room.events[0].startTime, end: room.events[0].endTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} });
          if (room.events.length === 1 && !moment(room.events[0].endTime).isSameOrAfter(moment(closingTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[0].endTime, end: closingTime, available: 'true'})
          }
        } else if (x != ArrLength && x > 0) {
          if (moment(room.events[x - 1].endTime).isSame(moment(room.events[x].startTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[x].startTime, end: room.events[x].endTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} });
          } else if (!moment(room.events[x - 1].endTime).isSame(moment(room.events[x].startTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[x - 1].endTime, end: room.events[x].startTime, available: 'true'});
            this.roomScheduleRooms[room.id].push({ start: room.events[x].startTime, end: room.events[x].endTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} });
          }
        } else if (x === ArrLength) {
          if (moment(room.events[ArrLength].endTime).isSameOrAfter(moment(closingTime)) && moment(room.events[x - 1].endTime).isSame(moment(room.events[x].startTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[ArrLength].startTime, end: closingTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} })
          } else if (!moment(room.events[ArrLength].endTime).isSameOrAfter(moment(closingTime)) && moment(room.events[x - 1].endTime).isSame(moment(room.events[x].startTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[ArrLength].startTime, end: room.events[ArrLength].endTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} })
            this.roomScheduleRooms[room.id].push({ start: room.events[ArrLength].endTime, end: closingTime, available: 'true'});
          } else if (!moment(room.events[ArrLength].endTime).isSameOrAfter(moment(closingTime)) && !moment(room.events[x - 1].endTime).isSame(moment(room.events[ArrLength].startTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[x - 1].endTime, end: room.events[ArrLength].startTime, available: 'true'});
            this.roomScheduleRooms[room.id].push({ start: room.events[ArrLength].startTime, end: room.events[ArrLength].endTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} });
            this.roomScheduleRooms[room.id].push({ start: room.events[ArrLength].endTime, end: closingTime, available: 'true'});
          } else if (moment(room.events[ArrLength].endTime).isSameOrAfter(moment(closingTime)) && !moment(room.events[x - 1].endTime).isSame(moment(room.events[x].startTime))) {
            this.roomScheduleRooms[room.id].push({ start: room.events[x - 1].endTime, end: room.events[ArrLength].startTime, available: 'true'});
            this.roomScheduleRooms[room.id].push({ start: room.events[ArrLength].startTime, end: closingTime, available: room.events[x].displayName || 'Booked', patronInfo: {first: firstName, last: last, lastName: lastName, barcode: barcode} });
          }
        }
      };
    } else {
      this.roomScheduleRooms[room.id].push({ start: openingTime, end: closingTime, available: 'true' });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-reserve/co-reserve.ts